import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  VERIFY_TOKEN_REQUEST,
  VERIFY_TOKEN_SUCCESS,
  VERIFY_TOKEN_FAILURE,
  CLEAR_PROFILE_MESSAGES
} from '../constants/profileConstants';

const initialState = {
  loading: false,
  error: null,
  success: false,
  message: null
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE_REQUEST:
    case CHANGE_PASSWORD_REQUEST:
    case VERIFY_EMAIL_REQUEST:
    case VERIFY_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };

    case EDIT_PROFILE_SUCCESS:
    case CHANGE_PASSWORD_SUCCESS:
    case VERIFY_EMAIL_SUCCESS:
    case VERIFY_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        message: action.payload.message || 'Operation completed successfully'
      };

    case EDIT_PROFILE_FAILURE:
    case CHANGE_PASSWORD_FAILURE:
    case VERIFY_EMAIL_FAILURE:
    case VERIFY_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };

    case CLEAR_PROFILE_MESSAGES:
      return {
        ...state,
        error: null,
        success: false,
        message: null
      };

    default:
      return state;
  }
};

export default profileReducer;